module.exports = __webpack_public_path__ + "img/Conversion rate Icon - white.57124e79.svg";